import axios from 'axios';
import {
  VehicleCarousel as Carousel, SkeletonLoader, CarouselVehicle, renderHTML, Button, CardTypes, Card
} from 'member-web-shared-components';
import React from 'react';
import { VehicleCarouselProps } from '../../types/App';
import './VehicleCarousel.scss';

const VehicleCarousel = (props: VehicleCarouselProps) => {
  const {
    title,
    buttonText,
    buttonUrl,
    componentId,
    disclaimer,
    endPoint
  } = props;

  const { useState, useEffect } = React;

  const [state, setState] = useState({
    vehicles: [] as CarouselVehicle[]
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(endPoint);
        setState({ vehicles: response.data });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    };

    fetchData();
  }, [endPoint]);

  const loadingCard = () => (
    <Card type={CardTypes.BORDER}>
      <div className='vehicle-carousel__skeleton-image'>
        <SkeletonLoader numberOfLines={1} testId='' />
      </div>
      <div className='vehicle-carousel__skeleton-name'>
        <SkeletonLoader numberOfLines={1} testId='' />
      </div>
      <div className='vehicle-carousel__skeleton-features'>
        <SkeletonLoader numberOfLines={1} testId='' />
        <SkeletonLoader numberOfLines={1} testId='' />
      </div>
      <div className='vehicle-carousel__skeleton-features'>
        <SkeletonLoader numberOfLines={1} testId='' />
        <SkeletonLoader numberOfLines={1} testId='' />
      </div>
    </Card>
  );

  const { vehicles } = state;

  return (
    <div
      data-testid={componentId}
      className='vehicle-carousel'
    >
      <div className='vehicle-carousel__wrapper'>
        <header className='vehicle-carousel__header'>
          {renderHTML(title, 'h2')}
          <Button priority='primary' linkButtonProps={{ url: buttonUrl }}>{buttonText}</Button>
        </header>
        <div className='vehicle-carousel__container'>
          {vehicles.length === 0 ? (
            <div className='vehicle-carousel__skeleton-container'>
              {loadingCard()}
              {loadingCard()}
              {loadingCard()}
              {loadingCard()}
            </div>
          ) : (
            <Carousel vehicles={vehicles} disclaimer={disclaimer} visibleSlides={4} />
          )}
        </div>
      </div>
    </div>
  );
};

export default VehicleCarousel;
